export default "__VITE_ASSET__CzzL$3hw__"